module.exports = __webpack_public_path__ + "static/media/greenBack1.73ad5c98.jpg";